<template>
    <div>
        <sau-template :retrieved="gotData">
            <template slot="message">Fetching Cpu Usage</template>

            <!-- Data -->
            <template slot="data">
                <!-- Graph it -->
                <div class="row">
                    <div class="col">
                        <h3>CPU Usage</h3>
                        <div class="sau-bx bx-pad">
                            <canvas
                                id="cpu-usage"
                                style="height:300px; width:100%;"
                                class="lazy-single-line-graph"
                                :data-points="JSON.stringify(usage)"
                            ></canvas>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            usage: ''
        };
    },
    created() {
        this.usage2 = JSON.stringify(this.usage2);
        this.startApp();
    },
    methods: {
        startApp() {
            this.getVpsUsageCpu()
                .then(response => {
                    if (response.data) {
                        this.usage = {
                            labels: response.data['labels'],
                            points: response.data['points'],
                            units: response.data['units']
                        };
                        this.$nextTick(() => {
                            this.registerAnimateOnView();
                        });
                    }
                })
                .catch(error => {});
        }
    }
};
</script>
